// src/api/tasks.api.js
import axiosInstance from './axiosInstance';

/**
 * جلب كل المهام
 */
export const fetchTasks = () =>
  axiosInstance.get('/tasks/');

/**
 * إنشاء مهمة واحدة (يدعم FormData للمرفقات)
 * @param {FormData|Object} payload
 */
export const createTask = (payload) =>
  axiosInstance.post('/tasks/', payload);

/**
 * إنشاء مهام مكررة لعدة مستخدمين
 * @param {FormData} payload
 */
export const bulkCreateTasks = (payload) =>
  axiosInstance.post('/tasks/bulk-create/', payload);

/**
 * تحديث مهمة (جزئي)
 * @param {number} id
 * @param {Object} payload - { status, assigned_to_id, ... }
 */
export const updateTask = (id, payload) =>
  axiosInstance.patch(`/tasks/${id}/`, payload);

/**
 * تحديث حالة مهمة فقط
 * @param {number} id
 * @param {string} status
 * @param {string|null} cancellationReason
 */
export const updateTaskStatus = (id, status, cancellationReason = null) => {
  const payload = { status };
  if (status === 'cancelled' && cancellationReason !== null) {
    payload.cancellation_reason = cancellationReason;
  }
  return axiosInstance.patch(`/tasks/${id}/`, payload);
};

/**
 * حذف مهمة
 * @param {number} id
 */
export const deleteTask = (id) =>
  axiosInstance.delete(`/tasks/${id}/`);